import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'

export default {
    taskName: taskName.REFINEMENT_CLARIFICATION_CALL,
    taskOverviewProps: {},
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
            readOnly: true,
        },
        {
            component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
        },
        {
            component: processUI.PHYSICIAN_AND_SUPPLIER_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_QUOTATION_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_DURATION_WIDGET_CONTAINER,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_PLAN_FILE_UPLOAD_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.STATE_TRANSITION_LOG_CONTAINER,
        },
    ],
    actionList: [
        {
            action: processAction.PROCESS_INSTANCE,
            taskPath: ['processInstance'],
        },
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
        {
            action: processAction.SALES_ORDER,
            taskPath: ['objectDetail'],
        },
        {
            action: processAction.CUSTOMER,
            taskPath: ['objectDetail', 'customer'],
        },
        {
            action: processAction.TREATMENT_QUOTATION,
            taskPath: ['objectDetail'],
        },
    ],
}



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/treatment/refinement-clarification-call.js